import { aosConfig } from './modules/aosConfig';
import { scrollHeader } from './modules/scrollHeader';

aosConfig();
scrollHeader();
